import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post("http://144.24.143.236:5000/api/auth/login", { email, password });
      if (res.data.status) {
        localStorage.setItem("token", res.data.data.token);
        navigate("/dashboard");
      } else {
        setError(res.data.message || "Login failed");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Cannot connect to server");
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .lg-root {
          min-height: 100vh;
          display: flex;
          font-family: 'DM Sans', sans-serif;
          background: #f8fafc;
        }

        /* ── Left Panel ── */
        .lg-left {
          flex: 1;
          background: linear-gradient(145deg, #0f172a 0%, #1e3a5f 55%, #1d4ed8 100%);
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          padding: 60px 48px; position: relative; overflow: hidden;
        }
        .lg-left::before {
          content: ''; position: absolute;
          width: 500px; height: 500px; border-radius: 50%;
          background: radial-gradient(circle, rgba(99,102,241,.18) 0%, transparent 65%);
          top: -120px; right: -120px;
        }
        .lg-left::after {
          content: ''; position: absolute;
          width: 350px; height: 350px; border-radius: 50%;
          background: radial-gradient(circle, rgba(37,99,235,.12) 0%, transparent 65%);
          bottom: -80px; left: -80px;
        }
        .lg-left-inner { position: relative; z-index: 1; max-width: 380px; }
        .lg-left-tag {
          display: inline-block; background: rgba(96,165,250,.15);
          color: #60a5fa; border: 1px solid rgba(96,165,250,.3);
          font-size: 11px; font-weight: 700; letter-spacing: 1.2px;
          text-transform: uppercase; padding: 5px 14px; border-radius: 20px; margin-bottom: 24px;
        }
        .lg-left-title {
          font-family: 'Syne', sans-serif; font-weight: 800;
          font-size: clamp(26px, 3vw, 36px); color: #fff;
          line-height: 1.15; margin-bottom: 16px;
        }
        .lg-left-title span { color: #60a5fa; }
        .lg-left-sub { color: #94a3b8; font-size: 14px; line-height: 1.7; margin-bottom: 36px; }

        .lg-feature {
          display: flex; align-items: flex-start; gap: 12px;
          margin-bottom: 18px;
        }
        .lg-feature-icon {
          width: 36px; height: 36px; border-radius: 10px;
          background: rgba(37,99,235,.3); display: flex;
          align-items: center; justify-content: center;
          font-size: 16px; flex-shrink: 0;
        }
        .lg-feature-text { font-size: 13px; color: #cbd5e1; line-height: 1.55; }
        .lg-feature-text strong { color: #e2e8f0; font-weight: 600; display: block; margin-bottom: 2px; }

        /* ── Right Panel ── */
        .lg-right {
          width: 480px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          padding: 48px 40px; background: #fff;
        }
        .lg-form-wrap { width: 100%; max-width: 380px; }

        .lg-logo { display: block; text-align: center; margin-bottom: 32px; }
        .lg-logo img { height: 56px; }

        .lg-form-title {
          font-family: 'Syne', sans-serif; font-weight: 800;
          font-size: 26px; color: #0f172a; margin-bottom: 6px; text-align: center;
        }
        .lg-form-sub { font-size: 14px; color: #94a3b8; text-align: center; margin-bottom: 32px; }

        .lg-label {
          display: block; font-size: 13px; font-weight: 600;
          color: #374151; margin-bottom: 7px;
        }
        .lg-input {
          width: 100%; padding: 12px 16px; border-radius: 10px;
          border: 1.5px solid #e2e8f0; font-size: 14px;
          font-family: 'DM Sans', sans-serif; color: #1e293b;
          background: #f8fafc; transition: border-color .2s, box-shadow .2s;
          outline: none;
        }
        .lg-input:focus { border-color: #2563eb; background: #fff; box-shadow: 0 0 0 3px rgba(37,99,235,.1); }
        .lg-input::placeholder { color: #cbd5e1; }

        .lg-pw-wrap { position: relative; }
        .lg-pw-toggle {
          position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
          background: none; border: none; cursor: pointer;
          color: #94a3b8; font-size: 16px; padding: 4px;
          transition: color .2s;
        }
        .lg-pw-toggle:hover { color: #2563eb; }

        .lg-field { margin-bottom: 20px; }

        .lg-error {
          background: #fef2f2; color: #dc2626; border-radius: 9px;
          padding: 10px 14px; font-size: 13px; font-weight: 500;
          margin-bottom: 18px; display: flex; align-items: center; gap: 8px;
        }

        .lg-submit {
          width: 100%; padding: 13px; border-radius: 10px;
          background: #2563eb; color: #fff; border: none;
          font-family: 'Syne', sans-serif; font-weight: 700; font-size: 15px;
          cursor: pointer; transition: background .2s, transform .15s, box-shadow .2s;
          box-shadow: 0 4px 16px rgba(37,99,235,.3); margin-top: 4px;
        }
        .lg-submit:hover:not(:disabled) {
          background: #1d4ed8; transform: translateY(-1px);
          box-shadow: 0 8px 24px rgba(37,99,235,.4);
        }
        .lg-submit:disabled { background: #93c5fd; cursor: not-allowed; transform: none; }

        .lg-divider {
          display: flex; align-items: center; gap: 12px;
          margin: 24px 0; color: #d1d5db; font-size: 12px;
        }
        .lg-divider::before, .lg-divider::after {
          content: ''; flex: 1; height: 1px; background: #e5e7eb;
        }

        .lg-back {
          display: block; text-align: center; font-size: 13px;
          color: #64748b; text-decoration: none; font-weight: 500;
          padding: 10px; border-radius: 8px; transition: color .2s, background .2s;
        }
        .lg-back:hover { color: #2563eb; background: #eff6ff; }

        .lg-spinner {
          display: inline-block; width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,.4); border-top-color: #fff;
          border-radius: 50%; animation: spin .7s linear infinite;
          margin-right: 8px; vertical-align: middle;
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        /* Responsive */
        @media (max-width: 900px) {
          .lg-left { display: none; }
          .lg-right { width: 100%; }
        }
        @media (max-width: 480px) {
          .lg-right { padding: 32px 24px; }
        }
      `}</style>

      <div className="lg-root">

        {/* ── Left Branding Panel ── */}
        <div className="lg-left">
          <div className="lg-left-inner">
            <div className="lg-left-tag">🤖 AI-Powered Hiring</div>
            <h1 className="lg-left-title">
              Find Your <span>Dream Job</span><br />with AI Precision
            </h1>
            <p className="lg-left-sub">
              Join over 200,000 professionals who found their perfect match using our intelligent recruitment platform.
            </p>

            {[
              { icon: "🎯", title: "Smart Matching", desc: "AI that matches your skills to the right roles automatically." },
              { icon: "⚡", title: "Instant Results", desc: "Get shortlisted in minutes, not days." },
              { icon: "🔒", title: "Verified Employers", desc: "Every company is verified and trusted." },
            ].map(f => (
              <div key={f.title} className="lg-feature">
                <div className="lg-feature-icon">{f.icon}</div>
                <div className="lg-feature-text">
                  <strong>{f.title}</strong>{f.desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Right Form Panel ── */}
        <div className="lg-right">
          <div className="lg-form-wrap">

            <Link to="/" className="lg-logo">
              <img src="assets/images/logo1.png" alt="Logo" />
            </Link>

            <h2 className="lg-form-title">Welcome Back</h2>
            <p className="lg-form-sub">Sign in to your account to continue</p>

            <form onSubmit={handleSubmit}>

              <div className="lg-field">
                <label className="lg-label">Email Address</label>
                <input
                  type="email"
                  className="lg-input"
                  placeholder="john@example.com"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>

              <div className="lg-field">
                <label className="lg-label">Password</label>
                <div className="lg-pw-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="lg-input"
                    placeholder="Enter your password"
                    style={{ paddingRight: 44 }}
                    required
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="lg-pw-toggle"
                    onClick={() => setShowPassword(p => !p)}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </button>
                </div>
              </div>

              {error && (
                <div className="lg-error">
                  ⚠️ {error}
                </div>
              )}

              <button type="submit" className="lg-submit" disabled={loading}>
                {loading && <span className="lg-spinner" />}
                {loading ? "Signing in..." : "Sign In →"}
              </button>

            </form>

            <div className="lg-divider">or</div>

            <Link to="/" className="lg-back">← Back to Home</Link>

          </div>
        </div>

      </div>
    </>
  );
}

export default Login;
